import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

export default class SpellCheckService {
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      words: [],
      status: '',
    });
  }

  replaceDictionaryWords = (text, dictionary) => {
    if (!dictionary) {
      return text;
    }
    return Object.keys(dictionary).reduce((result, word) => {
      if (!dictionary[word] || !dictionary[word].trim()) {
        return result;
      }
      const originalWord = word.replace(/[_]/g, '.');
      const escapedWord = originalWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return result.replace(new RegExp(`\\b${escapedWord}\\b`, 'g'), dictionary[word].trim());
    }, text);
  };

  handleSubmit = action((text, dictionary) => {
    text = this.replaceDictionaryWords(text, dictionary);
    return this.submit.fetch({
      method: 'post',
      url: '/speech-recognition/validate',
      body: {
        text,
      },
    }).then(() => {
      if (this.submit.data) {
        this.words = [];
        this.status = 'OK';
      }
      if (this.submit.error) {
        const detailMessage =
          this.submit.response && this.submit.response.data && this.submit.response.data.detail_message;
        this.words = detailMessage ? detailMessage.split(',').filter(Boolean) : [];
        this.status = 'ERROR';
      }
    });
  });
}
